<!-- 取消线上月票接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
        return {
            requestBody: {
                "carNo": "string",
                "billCode": "wdl1212312312312313del",
  "monthTicketId": 0,
  "parkCode": "2KPJZECG",
  "refundPrice": 3.0,
  "payMode": 4,
  "payModeRemark": "微信支付",
  "payOrigin": 7,
  "payOriginRemark": "智慧停车"
            },
            responseCode: {
                "data": {
                }, "message": "业务成功", "resultCode": 0, "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求智慧停车开放平台取消线上月票",
                t_url: this.commonUrls.test + "cancelOnlineVipTicket",
                p_url: this.commonUrls.prod + "cancelOnlineVipTicket",
                precondition: "无",
                fitSystem: "云停车场，VEMS传统车场",
                pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                        { info1: 'parkCode', info2: '是', info3: 'String', info4: '停车场编号' },
                        { info1: 'billCode', info2: '是', info3: 'String', info4: '第三方系统订单号（不超过30位）' },
                        { info1: 'carNo', info2: 'carNo跟monthTicketId二选一', info3: 'String', info4: '车牌号码' },
                        { info1: 'monthTicketId', info2: 'carNo跟monthTicketId二选一', info3: 'Long', info4: '月票id' },
                        { info1: 'refundPrice', info2: '是', info3: 'Decimal', info4: '退费金额' },
                        { info1: 'payOrigin', info2: '是', info3: 'Integer', info4: '支付来源，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payOriginRemark', info2: '否', info3: 'String', info4: '支付来源备注' },
                        { info1: 'payMode', info2: '是', info3: 'Integer', info4: '支付方式，<url>参考附录:/Api/appendixData</url>' },
                        { info1: 'payModeRemark', info2: '否', info3: 'String', info4: '支付方式备注' },
                        { info1: 'refundStartTime', info2: '否', info3: 'String', info4: '退款开始时间 yyyyMMddHHmmss（部分退费需传，仅支持退连续的时间）' },
                        { info1: 'refundEndTime', info2: '否', info3: 'String', info4: '退款结束时间 yyyyMMddHHmmss（部分退费需传，仅支持退连续的时间）' },
                        { info1: 'thirdBillCode', info2: '否', info3: 'String', info4: '开通月票时的第三方订单号（部分退费需传）' },
                    ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/ticket/cancelOnlineVipTicket.vue